import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Post } from 'src/app/shared/models/posts/post';

@Component({
  selector: 'app-task-word',
  templateUrl: './task-word.component.html',
  styleUrls: ['./task-word.component.scss']
})
export class TaskWordComponent implements OnInit {
  @Input() post: Post;

  public showDialogOk: boolean = false;
  public showDialogNotOk: boolean = false;
  public audioOk: any;
  public audioNotOk: any;

  public textValue = null;

  constructor(
    private _activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this._activatedRoute.params.subscribe(
      params => {    
        this.closeDialog();
        this.textValue = '';
      }
    ); 
    this.audioOk = new Audio();
    this.audioOk.src = "./assets/okrzyk.mp3";
    this.audioOk.load(); 
    this.audioNotOk = new Audio();
    this.audioNotOk.src = "./assets/niepowodzenie.mp3";
    this.audioNotOk.load();    
  }

  public showDialog() {
    return (this.showDialogNotOk || this.showDialogOk);
  }

  public closeDialog() {
    this.showDialogNotOk = false;
    this.showDialogOk = false;
  }

  public checkValue() {
    if (this._transformPassword(this.textValue) === this._transformPassword(this.post.game_word_2)) {
      this.showDialogOk = true;
      this.audioOk.play();
    } else {
      this.showDialogNotOk = true;
      this.audioNotOk.play();
    }    
  }

  private _transformPassword(password: string) {
    if (password === null) { return password; };
    let s = password.toLowerCase();
    // s = s.replace(/ę/ig,'e');
    // s = s.replace(/ż/ig,'z');
    // s = s.replace(/ó/ig,'o');
    // s = s.replace(/ł/ig,'l');
    // s = s.replace(/ć/ig,'c');
    // s = s.replace(/ś/ig,'s');
    // s = s.replace(/ź/ig,'z');
    // s = s.replace(/ń/ig,'n');
    // s = s.replace(/ą/ig,'a');
    return s;
  }  
}
